import { useState } from 'react';
import { useQuery, useMutation} from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

interface ProjectMemoListProps  {
  project_group_srl: number;
}
const useProjectMemoList = (params: ProjectMemoListProps) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [memoInfo, setMemoInfo] = useState<ProjectMemoInfoDto>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const { isLoading, refetch } = useQuery(
    [endpoints.project.memo.list, params],
    () =>
      fetcher.project.postProjectMemoList({
        id: Number(params.project_group_srl) || 0,
      }),
    {
      onSuccess: (res: ProjectMemoResDto) => {
        switch (res.code) {
          case 200:
            setMemoInfo(res.result?.info);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  
  const { mutate: memoInsert, isSuccess: insertSuccess } = useMutation(
    [endpoints.project.memo.add],
    fetcher.project.postProjectMemoInsert,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_INSERT, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: memoUpdate, isSuccess: updateSuccess } = useMutation(
    [endpoints.project.memo.update],
    fetcher.project.postProjectMemoUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  return { isLoading, refetch, memoInfo, memoInsert, memoUpdate };
};

export default useProjectMemoList;
